// extracted by mini-css-extract-plugin
export default {"container":"font-size-wrapper_container__oizWL"};